module.exports = "<ng-container *ngFor=\"let tax of taxonomies\">\n    <span class=\"chip\">{{api.taxonomies[tax]?.name}}</span>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/taxonomies.component.html
// module id = ../../../../../src/swarm/src/app/fields/taxonomies.component.html
// module chunks = main